/**
 * Invalidates all React Query cache entries related to a given endpoint:
 *  - ['list', endpoint]          — list views (useListData)
 *  - ['listWidget', entity]      — dashboard list widgets (ListWidget)
 * For subcollection endpoints (e.g. "customer/123/contact") the parent
 * entity list and the sub-entity widget are also invalidated.
 */
const invalidateListQueries = async (endpoint, queryClient) => {
  await queryClient.invalidateQueries({ queryKey: ['list', endpoint] })
  // Flush any dashboard list widgets that show this entity
  const segments = endpoint.split('/')
  await queryClient.invalidateQueries({ queryKey: ['listWidget', segments[0]] })
  // For subcollections: also flush the parent list and sub-entity widget
  if (segments.length > 1) {
    await queryClient.invalidateQueries({ queryKey: ['list', segments[0]] })
    const subEntity = segments[segments.length - 1]
    await queryClient.invalidateQueries({ queryKey: ['listWidget', subEntity] })
  }
}

export default invalidateListQueries
